import { createShallowStore, createStore } from '@frontend/store';

type State = {
  currentFormInPacketIndex: number;
};

type Actions = {
  goToNextFormInPacket: () => void;
  goToPreviousFormInPacket: () => void;
  resetFormInPacketIndex: () => void;
};

const initialState: State = {
  currentFormInPacketIndex: 0,
};

type FormPacketStore = State & Actions;

const useStore = createStore<FormPacketStore>(
  (set) => ({
    ...initialState,
    goToNextFormInPacket: () => set((state) => ({ currentFormInPacketIndex: state.currentFormInPacketIndex + 1 })),
    goToPreviousFormInPacket: () =>
      set((state) => ({
        currentFormInPacketIndex: state.currentFormInPacketIndex > 0 ? state.currentFormInPacketIndex - 1 : 0,
      })),
    resetFormInPacketIndex: () => set({ currentFormInPacketIndex: 0 }),
  }),
  { name: 'FormPacketStore', trace: true }
);

export const useFormPacketShallowStore = createShallowStore(useStore);
